;(function () {
  'use strict';

  var config = {
    headerID: '#header',
    wrapperClass: '.column-wrapper',
    mainClass: '.column--main',
    subClass: '.column--sub',
    asideClass: '.column--aside',
    sidebarInnerClass: '.sidebar__inner',
    sidebarMargin: 15,
  };

  var $header, $wrapper, $main, $sub, $aside;

  $(function () {
    $header = $(config.headerID);
    $wrapper = $(config.wrapperClass);
    $main = $(config.mainClass);
    $sub = $(config.subClass);
    $aside = $(config.asideClass);

    // 対象要素がない
    if (!$wrapper.length || !$main.length || (!$sub.length && !$aside.length)) {
      return false;
    }

    var headerHeight = $header.outerHeight();

    if ($sub.length) {
      var subSticky = new StickySidebar(config.subClass, {
        containerSelector: config.wrapperClass,
        innerWrapperSelector: config.sidebarInnerClass,
        topSpacing: headerHeight + config.sidebarMargin,
        bottomSpacing: config.sidebarMargin,
      });
    }

    if ($aside.length) {
      var asideSticky = new StickySidebar(config.asideClass, {
        containerSelector: config.wrapperClass,
        innerWrapperSelector: config.sidebarInnerClass,
        topSpacing: headerHeight + config.sidebarMargin,
        bottomSpacing: config.sidebarMargin,
      });
    }
  });
}.call(this));